import { QueryClient } from '@tanstack/react-query';

/**
 * Custom QueryClient with caching defaults.
 *
 * staleTime (2 min): data is considered fresh for this period;
 * duplicate useGetList/useGetOne calls within the window are served
 * from cache without hitting the API.
 *
 * gcTime (10 min): unused cache entries are garbage-collected after
 * this period (renamed from cacheTime in TanStack Query v5).
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,  // 2 minutes
      gcTime: 10 * 60 * 1000,    // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default queryClient;
